import React, { ReactElement } from 'react'

function Step2TooltipRevenueCard(): ReactElement {
  return (
    <div className="card cardSm textPrimaryDark w23 fontSizeXs">
      <p>
        Montant saisi dans votre dernière déclaration annuelle de revenus
        rapporté au mois, c’est-à-dire divisé par 12. Il s’agit également du «
        montant net fiscal » ou « net imposable » indiqué sur votre bulletin de
        salaire dans le cas de revenus composés d’un salaire unique.
      </p>
    </div>
  )
}

export default Step2TooltipRevenueCard
